import APIService from "./APIService";

class BoxesService extends APIService {
  add = async (
    name: string,
    price: number,
    description: string,
    season: any,
    products: string[],
    recipe: string,
    start_at: any,
    end_at: any,
    seasonal_packages: string[]
  ) => {
    const result = await this.post(
      { name, price, description, season, products, recipe, start_at, end_at, seasonal_packages },
      "boxes"
    );
    return result ? result.data : null;
  };

  addSeasonalBox = async (
    box_id: string,
    boxType: string,
    sub_boxes: string[]
  ) => {
    const result = await this.post(
      { box_id, boxType, sub_boxes },
      "boxes/seasonal"
    );
    return result ? result.data : null;
  };

  updateSeasonalBox = async (
    name: string,
    description: string,
    boxType: string,
    sub_boxes: string[],
    _id: string
  ) => {
    const result = await this.put(
      { name, description, boxType, sub_boxes },
      "boxes/seasonal/" + _id
    );
    return result ? result.data : null;
  };

  search = async (
    search: string = "",
    page: number = 1,
    limit: number = 10,
    sort: string
  ) => {
    const result = await this.get(
      "boxes/search?generic=" +
        search +
        "&page=" +
        page +
        "&limit=" +
        limit +
        "&sort=" +
        sort
    );
    return result ? result.data : null;
  };

  getBox = async (id: string) => {
    const result = await this.get("boxes/" + id);
    return result ? result.data : null;
  };

  searchByGeneral = async (query?: string): Promise<[]> => {
    try {
      const result = await this.get(
        "boxes/search/general" +
          (query ? "?query=" + encodeURIComponent(query) : "")
      );
      return result ? result.data : [];
    } catch (error: any) {
      throw new Error(`Failed to search boxes: ${error.message}`);
    }
  };

  searchBySeason = async (): Promise<[]> => {
    try {
      const result = await this.get("boxes/search/seasonal");
      return result ? result.data.boxes : [];
    } catch (error: any) {
      throw new Error(`Failed to search boxes: ${error.message}`);
    }
  };

  getBoxes = async(query?: string): Promise<[]> => {
    try {
      const result = await this.get("boxes/get-boxes" + (query ? "?query=" + encodeURIComponent(query) : ""));
      return result ? result.data : [];
    } catch (error: any) {
      throw new Error(`Failed to get boxes: ${error.message}`);
    }
  }

  edit = async (
    name: string,
    price: number,
    description: string,
    season: any,
    products: string[],
    recipe: string,
    start_at: any,
    end_at: any,
    seasonal_packages: string[],
    id: string
  ) => {
    const result = await this.put(
      { name, price, description, season, products, recipe, start_at, end_at, seasonal_packages },
      "boxes/" + id
    );
    return result ? result.data : null;
  };

  delete = async (id: string) => {
    const result = await this.remove("boxes/" + id);
    return result ? result.data : null;
  };
}

export default BoxesService;
